import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=a39afdbc&scoped=true&"
import script from "./EditContact.vue?vue&type=script&lang=js&"
export * from "./EditContact.vue?vue&type=script&lang=js&"
import style0 from "./EditContact.vue?vue&type=style&index=0&id=a39afdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39afdbc",
  null
  
)

export default component.exports